export default __webpack_public_path__ + "fef87d4a518c764d15334afa832ee419.png";